import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=4369d98c&scoped=true&"
import script from "./testPaper.vue?vue&type=script&lang=js&"
export * from "./testPaper.vue?vue&type=script&lang=js&"
import style0 from "./testPaper.vue?vue&type=style&index=0&id=4369d98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369d98c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4369d98c')) {
      api.createRecord('4369d98c', component.options)
    } else {
      api.reload('4369d98c', component.options)
    }
    module.hot.accept("./testPaper.vue?vue&type=template&id=4369d98c&scoped=true&", function () {
      api.rerender('4369d98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/testPaper.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/testPaper.vue
// module id = OfVB
// module chunks = 0